import { FC, useState } from 'react';
import { Spin } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { FaRegFolder } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';
import EmptyHorizontal from 'components/EmptyHorizontal';
import TextCopyable from 'components/TextCopyable';
import appRoutes from 'config/appRoutes';

interface ProjectsCardProps {
  projects?: Record<string, any>[];
  showAllProjects?: boolean;
  onShowAllProjects?: (show: boolean) => Promise<void>;
}

const ProjectsCard: FC<ProjectsCardProps> = ({ projects, showAllProjects, onShowAllProjects }) => {
  const [fetching, setFetching] = useState(false);

  const onShowAllProjectsHandler = (event: CheckboxChangeEvent) => {
    if (onShowAllProjects) {
      setFetching(true);
      onShowAllProjects(event.target.checked).finally(() => setFetching(false));
    }
  };

  return (
    <div style={{ marginTop: 20 }}>
      <div className="mb-s" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: 16, fontWeight: 500 }}>Plan</span>
      </div>

      <Spin spinning={fetching}>
        {projects && projects?.length > 0 && (
          <div style={{ border: '1px solid #0044CC33', borderRadius: 4, padding: '8px 12px' }}>
            {projects?.map((project) => (
              <div key={project.uuid} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, overflow: 'hidden' }}>
                  <FaRegFolder style={{ flex: 'none' }} />

                  <div className="secondary" style={{ overflow: 'hidden' }}>
                    <TextCopyable>{project.title}</TextCopyable>
                  </div>
                </div>

                <Link to={`${appRoutes.PROJECTS}/${project.uuid}`}>
                  <FiExternalLink />
                </Link>
              </div>
            ))}
          </div>
        )}

        {projects?.length === 0 && <EmptyHorizontal description="There is no plans" />}
      </Spin>
    </div>
  );
};

export default ProjectsCard;
